<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let field_data;
    export let input_value;
    export let col_class="";
    export let input_valid = true;
    export let was_submitted = false;
    let was_touched;
    let is_focused

</script>

<div class="form-group {col_class}">
    <label for={field_data.id}
        >{field_data.label || field_data.placeholder}</label
    >
    {#if field_data.tooltip}
        <span class="tooltip-container ml-1">
            <i class="fa-solid fa-circle-info fa-xs" style="color:#009FDF;"></i>
            <div class="tooltip">{field_data.tooltip}</div>
        </span>
    {/if}
    <input
        on:focus={() => {  is_focused = true; }}
        on:blur={() => { is_focused = false;was_touched = true; }}
        bind:value={input_value}
        id={field_data.id}
        class="form-control {(was_submitted || was_touched) && !is_focused
                        ? input_valid
                            ? 'is-valid'
                            : 'is-invalid'
                        : ''}"
        type="text"
        placeholder={field_data.placeholder}
        maxlength={field_data.max_length}
        autocomplete="off"
    />
    {#if !input_valid && (was_touched || was_submitted)}
        <div class="invalid-feedback" style="display:block; font-size:90%;">
            {field_data.error_message}
        </div>
    {/if}
</div>
